import useLenis from "../components/useLenis";
import DonateHero   from "./DonateHero";
import DonateImpact from "./DonateImpact";
import DonateForm   from "./DonateForm";
import Footer       from "../components/Home/Footer";

export default function DonatePage() {
  useLenis();
  return (
    <>
      <DonateHero />
      <DonateImpact />
      <DonateForm />
      <Footer />
    </>
  );
}
